module.exports = __webpack_public_path__ + "static/media/4.0209f7df.jpg";